var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PreviewInfoAdvisorComponent',{key:_vm.keyComponent})
}
var staticRenderFns = []

export { render, staticRenderFns }